function escapeCsvValue(value) {
  if (value === null || value === undefined) {
    return '';
  }

  const text = String(value);
  if (/[",\n\r]/.test(text)) {
    return `"${text.replaceAll('"', '""')}"`;
  }
  return text;
}

export function buildCsv(rows) {
  if (!rows.length) {
    return '';
  }

  const headers = [...new Set(rows.flatMap((row) => Object.keys(row)))];
  const lines = [headers.map(escapeCsvValue).join(',')];
  for (const row of rows) {
    lines.push(headers.map((header) => escapeCsvValue(row[header])).join(','));
  }
  return lines.join('\n');
}

export function buildExportFilename({ method, direction, scope, date = new Date() }) {
  const datePart = date.toISOString().slice(0, 10);
  return `brendo_${method}_${direction}_${scope}_${datePart}.csv`;
}

export function downloadCsv(
  rows,
  filename,
  { documentRef = document, urlApi = URL } = {},
) {
  const blob = new Blob([`\ufeff${buildCsv(rows)}`], { type: 'text/csv;charset=utf-8' });
  const objectUrl = urlApi.createObjectURL(blob);
  const link = documentRef.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  documentRef.body.appendChild(link);
  link.click();
  link.remove();
  urlApi.revokeObjectURL(objectUrl);
}
